(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dabeasy-showcase"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dabeasy-showcase')) {
  customElements.define('dabeasy-showcase', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };

      this.drawers = [];
      this.querySelectorAll('.de-ending__details .de-details').forEach(details => {
        const summary = details.querySelector('summary');
        const drawer = { details, animation: null, expanded: details.open };
        this.drawers.push(drawer);
        summary.setAttribute('aria-expanded', String(drawer.expanded));
        summary.addEventListener('click', event => {
          event.preventDefault();
          const startHeight = details.getBoundingClientRect().height;
          drawer.expanded = !drawer.expanded;
          summary.setAttribute('aria-expanded', String(drawer.expanded));
          if (drawer.animation) {
            drawer.animation.onfinish = null;
            drawer.animation.cancel();
          }
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !details.animate) {
            details.open = drawer.expanded;
            details.style.removeProperty('overflow');
            drawer.animation = null;
            return;
          }
          details.open = true;
          details.style.overflow = 'hidden';
          const endHeight = drawer.expanded
            ? details.getBoundingClientRect().height
            : summary.getBoundingClientRect().height + parseFloat(getComputedStyle(details).borderBottomWidth || 0);
          drawer.animation = details.animate(
            { height: [startHeight + 'px', endHeight + 'px'] },
            { duration: 480, easing: 'cubic-bezier(.22, .61, .36, 1)' }
          );
          drawer.animation.onfinish = () => {
            details.open = drawer.expanded;
            details.style.removeProperty('overflow');
            drawer.animation = null;
          };
        }, options);
      });

      const hero = this.querySelector('.de-hero');
      this.measure = () => this.style.setProperty('--de-top', `${Math.max(0, hero.getBoundingClientRect().top + window.scrollY)}px`);
      this.measure();
      const quote = this.querySelector('[data-de-quote-form]');
      if (quote && (quote.querySelector('.de-form-status') || window.location.hash === '#DabEasyContact')) quote.open = true;
      this.querySelectorAll('a[href^="#"]').forEach(link => link.addEventListener('click', event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const target = document.getElementById(link.getAttribute('href').slice(1));
        if (!target) return;
        event.preventDefault();
        if (target.id === 'DabEasyQuote' && quote) quote.open = true;
        const header = document.querySelector('sticky-header');
        const headerHeight = header ? header.getBoundingClientRect().height : 0;
        const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - headerHeight - 24);
        window.history.pushState(null, '', link.getAttribute('href'));
        window.scrollTo({ top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, options));
      window.addEventListener('resize', this.measure, options);
      this.observer = new ResizeObserver(this.measure);
      document.querySelectorAll('.shopify-section-group-header-group').forEach(element => this.observer.observe(element));
      this.viewport = this.querySelector('.de-gallery__viewport');
      const track = this.querySelector('.de-gallery__track');
      const original = this.querySelector('.de-gallery__set');
      if (!original.children.length) return;
      [0, 1].forEach(() => { const clone = original.cloneNode(true); clone.setAttribute('aria-hidden', 'true'); track.appendChild(clone); });
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.stopped = this.reduced.matches;
      this.hovered = false;
      this.focused = false;
      this.until = 0;
      const toggle = this.querySelector('[data-de-toggle]');
      const syncToggle = () => { toggle.setAttribute('aria-pressed', String(this.stopped)); toggle.setAttribute('aria-label', this.stopped ? toggle.dataset.playLabel : toggle.dataset.pauseLabel); toggle.firstElementChild.textContent = this.stopped ? '▶' : 'Ⅱ'; };
      syncToggle();
      toggle.addEventListener('click', () => { this.stopped = !this.stopped; syncToggle(); }, options);
      const cycleWidth = () => original.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
      this.viewport.scrollLeft = cycleWidth();
      const move = direction => { this.until = performance.now() + 5000; const card = original.firstElementChild; const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(original).gap || 0); this.viewport.scrollBy({ left: direction * step, behavior: this.reduced.matches ? 'instant' : 'smooth' }); };
      this.querySelector('[data-de-prev]').addEventListener('click', () => move(-1), options);
      this.querySelector('[data-de-next]').addEventListener('click', () => move(1), options);
      this.viewport.addEventListener('keydown', event => { this.focused = true; if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1); } }, options);
      this.viewport.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch') this.hovered = true; }, options);
      this.viewport.addEventListener('pointerleave', () => { this.hovered = false; this.focused = false; this.until = 0; }, options);
      this.viewport.addEventListener('focusin', () => { this.focused = this.viewport.matches(':focus-visible'); }, options);
      this.viewport.addEventListener('focusout', () => this.focused = false, options);
      this.viewport.addEventListener('wheel', () => this.until = performance.now() + 5000, { ...options, passive: true });
      this.viewport.addEventListener('touchstart', () => this.until = performance.now() + 8000, { ...options, passive: true });
      this.viewport.addEventListener('pointerdown', event => { if (event.pointerType !== 'mouse') return; this.focused = false; this.dragMoved = false; this.dragging = true; this.startX = event.clientX; this.startScroll = this.viewport.scrollLeft; this.viewport.setPointerCapture(event.pointerId); }, options);
      this.viewport.addEventListener('pointermove', event => { if (this.dragging) { this.dragMoved = this.dragMoved || Math.abs(event.clientX - this.startX) > 4; this.viewport.scrollLeft = this.startScroll - (event.clientX - this.startX); } }, options);
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(name => this.viewport.addEventListener(name, () => { this.dragging = false; this.until = 0; }, options));
      this.position = this.viewport.scrollLeft;
      this.lastTime = 0;
      const animate = time => {
        const delta = Math.min(time - (this.lastTime || time), 50);
        this.lastTime = time;
        if (!this.stopped && !this.hovered && !this.focused && !this.dragging && !document.hidden && time > this.until) { this.position += delta * .023; this.viewport.scrollLeft = this.position; } else { this.position = this.viewport.scrollLeft; }
        const width = cycleWidth();
        if (width > 0 && (this.viewport.scrollLeft >= width * 2 || this.viewport.scrollLeft < 1)) { this.viewport.scrollLeft += this.viewport.scrollLeft >= width * 2 ? -width : width; this.position = this.viewport.scrollLeft; }
        this.frame = requestAnimationFrame(animate);
      };
      this.frame = requestAnimationFrame(animate);
      this.reduced.addEventListener('change', () => { this.stopped = this.reduced.matches; syncToggle(); }, options);
    }
    disconnectedCallback() { this.drawers?.forEach(drawer => { if (drawer.animation) { drawer.animation.onfinish = null; drawer.animation.cancel(); } drawer.details.open = drawer.expanded; drawer.details.style.removeProperty('overflow'); }); this.abort?.abort(); this.observer?.disconnect(); cancelAnimationFrame(this.frame); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
